module.exports = __webpack_public_path__ + "img/CX_Actions_Logo.04a991e0.png";